<div class="p-3">
    [{{ environmentsInformation.app.version }}] {{ environmentsInformation.app.name }}<br>
    [{{ environmentsInformation.server.version }}] {{ environmentsInformation.server.name }}
</div>